module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Regular-Alphabetic.6094abde.woff2";